module.exports = __webpack_public_path__ + "img/logo-footer-1.c1a310f4.png";